import {
  AudioLines,
  Bot,
  Boxes,
  Brain,
  Calendar,
  Cloud,
  Code,
  Cpu,
  Database,
  FileText,
  Globe,
  HardDrive,
  Image,
  Languages,
  Mail,
  MessageSquare,
  Mic,
  Moon,
  Play,
  Search,
  ShieldCheck,
  Sparkles,
  Wrench,
  Zap,
  type LucideIcon,
} from "lucide-react";
import type { ServiceKind } from "@woodpecker/protocol";
import { cn } from "./cn";

/** The icons a service may choose at deploy (the mock's list), all lucide line icons. */
export const ICONS: Record<string, LucideIcon> = {
  cpu: Cpu,
  database: Database,
  sparkles: Sparkles,
  wrench: Wrench,
  cloud: Cloud,
  bot: Bot,
  brain: Brain,
  "audio-lines": AudioLines,
  mic: Mic,
  languages: Languages,
  "shield-check": ShieldCheck,
  boxes: Boxes,
  "hard-drive": HardDrive,
  globe: Globe,
  zap: Zap,
  "message-square": MessageSquare,
  image: Image,
  code: Code,
  search: Search,
  mail: Mail,
  calendar: Calendar,
  "file-text": FileText,
  play: Play,
  moon: Moon,
};

export const KIND_ICON: Record<ServiceKind, string> = {
  runner: "cpu",
  memory: "database",
  model: "sparkles",
  tool: "wrench",
  host: "cloud",
  store: "archive",
};

export function isIcon(name: string): boolean {
  return name in ICONS;
}

export function iconOf(entry: { icon?: string; kinds: ServiceKind[] }): string {
  const i = entry.icon?.trim() ?? "";
  return isIcon(i) ? i : KIND_ICON[entry.kinds[0] ?? "tool"];
}

export function ServiceIcon({
  entry,
  icon,
  kind,
  className,
}: {
  entry?: { icon?: string; kinds: ServiceKind[] };
  icon?: string;
  kind?: ServiceKind;
  className?: string;
}) {
  const name = icon?.trim() ?? "";
  const Icon = ICONS[isIcon(name) ? name : entry ? iconOf(entry) : KIND_ICON[kind ?? "tool"]] ?? Wrench;
  return <Icon aria-hidden className={cn("size-4.5 shrink-0 text-muted-foreground", className)} strokeWidth={1.75} />;
}
